export function toFiscalUppercase(value: string): string {
    return value.toLocaleUpperCase('es-MX');
}

export function trimFiscalUppercase(value: string): string {
    return toFiscalUppercase(value.trim());
}
